import {
  ActivePromotion,
  OnboardingPromotionApplyRequest,
  PromotionAssignRequest,
  PromotionCode,
  PromotionCodeCreateRequest,
  PromotionFacilityAssignment,
  PromotionPeriodCreateRequest,
  PromotionUnassignRequest,
} from "../types/promotion.definition";
import {
  applyOnboardingPromotion,
  assignPromotion,
  createPromotionCode,
  createPromotionPeriod,
  deletePromotionCode,
  getActiveFacilityPromotions,
  getOnboardingPromotions,
  getPromotionCodes,
  getPromotionFacilities,
  unassignPromotion,
  updatePromotionPeriod,
} from "../webclients/promotion.client";

export const promotionApi = {
  getPromotionCodes: async (): Promise<PromotionCode[]> => {
    const response = await getPromotionCodes();
    return response.data;
  },

  createPromotionCode: async (
    data: PromotionCodeCreateRequest
  ): Promise<PromotionCode> => {
    const response = await createPromotionCode(data);
    return response.data;
  },

  deletePromotionCode: async (id: number): Promise<void> => {
    await deletePromotionCode(id);
  },

  createPromotionPeriod: async (
    data: PromotionPeriodCreateRequest
  ): Promise<PromotionCode> => {
    const response = await createPromotionPeriod(data);
    return response.data;
  },

  assignPromotion: async (data: PromotionAssignRequest): Promise<void> => {
    await assignPromotion(data);
  },

  getOnboardingPromotions: async (): Promise<PromotionCode[]> => {
    const response = await getOnboardingPromotions();
    return response.data;
  },

  applyOnboardingPromotion: async (
    data: OnboardingPromotionApplyRequest
  ): Promise<void> => {
    await applyOnboardingPromotion(data);
  },

  getPromotionFacilities: async (
    promotionKey: number
  ): Promise<PromotionFacilityAssignment[]> => {
    const response = await getPromotionFacilities(promotionKey);
    return response.data;
  },

  unassignPromotion: async (data: PromotionUnassignRequest): Promise<void> => {
    await unassignPromotion(data);
  },

  updatePromotionPeriod: async (
    promotionKey: number,
    data: { startDate: string; endDate: string }
  ): Promise<PromotionCode> => {
    const response = await updatePromotionPeriod(promotionKey, data);
    return response.data;
  },

  getActiveFacilityPromotions: async (
    facilityId: number
  ): Promise<ActivePromotion[]> => {
    const response = await getActiveFacilityPromotions(facilityId);
    return response.data;
  },
};
